import React, {useState} from 'react';
import './Market.scss'
import marketImg from '../Assets/market/market.png' 

import Filter from './Filter/Filter';
import GalleryBlock from './GalleryBlock/GalleryBlock';
import MarketplaceBlock from './MarketplaceBlock/MarketplaceBlock';

import MarketplaceSlider from './MarketplaceSlider/MarketplaceSlider';

import NTF1 from '../Assets/home/nft1.png'
import NTF2 from '../Assets/home/nft2.png'
import NTF3 from '../Assets/home/nft3.png'
import NTF4 from '../Assets/home/nft4.png'
import NTF5 from '../Assets/home/nft5.png'
import NTF6 from '../Assets/home/nft6.png'
import NTF7 from '../Assets/home/nft7.png'

import NftDemo1 from '../Assets/home/05china05.png'
import NftDemo2 from '../Assets/home/04china04.png'
function Market(props){
    
    const ExploreFilters = [
        {title: 'All', active: true}, 
        {title: 'Art', active: false}, 
        {title: 'Crypto', active: false}, 
        {title: 'Gaming', active: false}, 
        {title: 'Business', active: false}, 
        {title: 'Media', active: false}, 
        {title: 'Sports', active: false}
    ]

    const explorerValues = [
        {img: NTF1, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF2, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: false},
        {img: NTF3, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF4, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: 'Bundle of 5', pack: false},      
        {img: NTF6, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
        {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: 'SOLD', lastBet: false, bundle: false, pack: false},      
        {img: NTF7, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
        {img: NTF1, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF2, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: false},
        {img: NTF3, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF4, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF6, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
        {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: 'SOLD', lastBet: false, bundle: false, pack: false}
    ]

    let [postNum, setPostNum] = useState(8)
    let [loadMore, setLoadMore] = useState("load more")

    function showMore(){
        if(postNum < explorerValues.length - 4){
          setPostNum(postNum+4)
        }else if(postNum < explorerValues.length){
          setPostNum(postNum + (explorerValues.length-postNum))
          setLoadMore("No more NFT'S")
        }
    }

    const nftSlidesImgs = [
        {value: "Demo Title0", img: NftDemo1},
        {value: "Demo Title1", img: NftDemo2},
        {value: "Demo Title2", img: NftDemo2},
        {value: "Demo Title1", img: NftDemo2},
        {value: "Demo Title2", img: NftDemo2},      
        {value: "Demo Title2", img: NftDemo2}
    ]

    let  [exampleSliderShow] = useState(4)
    if(window.innerWidth <= 1024 && window.innerWidth >= 800){
        exampleSliderShow = 3
      }else if(window.innerWidth <= 800 && window.innerWidth >= 600){
        exampleSliderShow = 2
      }else if(window.innerWidth <= 600){
        exampleSliderShow = 1
      }
    return(
        <div className={props.darkMode ? "market dark" : "market"}>
            <img src={marketImg} alt="market" className="market_img"/>
            <Filter arr={ExploreFilters}  darkMode={props.darkMode}/>
            <div className="market_content">
                <div className="explorer">
                    <h1>Explore</h1>
                    <div className="home_gallery" style={{ display: 'flex', flexWrap: 'wrap'}}>
                      <GalleryBlock nftBlocks={explorerValues} postNum={8} darkMode={props.darkMode} />
                    </div>
                </div>
                <div className="top_bids">
                  <h1>Top bids</h1>
                  <MarketplaceSlider darkMode={props.darkMode} nftSlidesImgs={nftSlidesImgs} component={ MarketplaceBlock } slidesPerRow={1} slidesToShow={exampleSliderShow}/>
                </div>
                <div className="explorer">
                    <h1>Explore</h1>
                    <div className="home_gallery" style={{ display: 'flex', flexWrap: 'wrap'}}>
                      <GalleryBlock nftBlocks={explorerValues} postNum={postNum} darkMode={props.darkMode} />
                    </div>
                    <button onClick={() => showMore()} className="load_more">{loadMore}</button>
                </div>
            </div>
        </div>
    )
}

export default Market;